exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_articles_2pj7lbFpJ8n_Qm7LshSdxn {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_1tQOHQgX4MXSOUAGS3Rt_W {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_1wbXUksnUqInmIDbIqd7P0 {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_3BJaqVJI1oC4RyE1ee0ppD {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_articles": "IA_articles_2pj7lbFpJ8n_Qm7LshSdxn",
	"IA_filters": "IA_filters_1tQOHQgX4MXSOUAGS3Rt_W",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_1wbXUksnUqInmIDbIqd7P0",
	"IA_paginationPageCount": "IA_paginationPageCount_3BJaqVJI1oC4RyE1ee0ppD"
};